export default [
  {
    path: '/pemrek-mandiri-verify',
    name: 'pemrek-mandiri-verify',
    component: () => import('@/views/pemrek-mandiri-verify/index.vue'),
    props: true,
    meta: {
      pageTitle: 'Bukti Pemrek Mandiri',
      breadcrumb: [
        {
          text: 'Bukti Pemrek Mandiri',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pemrek-mandiri-verify/add',
    name: 'pemrek-mandiri-verify-add',
    component: () => import('@/views/pemrek-mandiri-verify/create/index.vue'),
    meta: {
      pageTitle: 'Bukti Pemrek Baru',
      breadcrumb: [
        {
          text: 'Bukti Pemrek Mandiri',
          to: '/pemrek-mandiri-verify'
        },
        {
          text: 'Bukti Pemrek Baru',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pemrek-mandiri-verify/detail',
    name: 'pemrek-mandiri-verify-detail',
    component: () => import('@/views/pemrek-mandiri-verify/detail/index.vue'),
    meta: {
      pageTitle: 'Bukti Pemrek Baru',
      breadcrumb: [
        {
          text: 'Bukti Pemrek Mandiri',
          to: '/pemrek-mandiri-verify'
        },
        {
          text: 'Bukti Pemrek Mandiri',
          active: true,
        },
      ],
    },
  },
  
]